import axios from 'axios';
import { reportGeneratorPrivClient } from '../api';

/**
 * Envia para o GAS template o payload para
 * geracao do relatorio e recupera a url de
 * acesso para o resultado do relatorio
 */
export async function postGASForURL(payload) {
  const {
    surveyTitle,
    survey,
    client_name,
    questions,
    customization
  } = payload;

  const requestPayload = {
    surveyTitle,
    survey,
    client_name,
    questions,
    customization
  };

  const result = await reportGeneratorPrivClient
    .post('/v1/report/apresentacao', requestPayload);

  const redirectTo = result.data.url;
  return redirectTo;
}
